import { CDN_IMG_URL } from "@casino/legacy/shared/cdn/url";

// Callers pass both "icons/x.svg" and "/icons/x.svg"; don't double the slash.
const getCdnImg = (src = "", ext = "") =>
  `${CDN_IMG_URL}/${src.replace(/^\/+/, "")}${ext}`;

export default getCdnImg;
